import {
  AppBar,
  IconButton,
  InputBase,
  Toolbar,
  Typography
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded'
import Menu from '@material-ui/icons/Menu'
import SearchIcon from '@material-ui/icons/Search'
import classnames from 'classnames'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { bindActionCreators, compose } from 'redux'

import { Logo } from 'components'
import Drawer from 'components/Drawer'
import { ParentalInstructions } from 'components/ParentalInstructions'
import { IPopoverButtonOptions, PopoverButton } from 'components/PopoverButton'
import ShareModal from 'components/ShareModal'
import TeachersModal from 'components/TeachersModal'
import { ITeacher } from 'components/TeachersModal/types'
import { supportEmail } from 'config'
import { _route } from 'routes/config'
import DrawerService from 'services/drawer'
import { clearPlusUser } from 'services/plusUsers'
import SnackbarService from 'services/snackbars'
import { isEducator } from 'services/user'
import * as PatientActions from 'store/patients/actions'
import * as PlusUserActions from 'store/plusUsers/actions'
import * as UserActions from 'store/user/actions'
import './style.scss'

interface INativeProps {
  title?: string
  type?: string
  hasMenu?: boolean
  smallHeader?: boolean
  plusIconAction?: any
  searchFieldAction?: any
  goBackAction?: any
  customComponent?: any
  disableBackButton?: boolean
  searchFieldPlaceholder?: string
  oneRow?: boolean
  rightSide?: any
  defaultRightSide?: boolean
  currChildListener?: any
  className?: string
}

interface IReduxStateProps {
  user?: any
  plusUser: any
  userAuth: any
  currentPatient: any
}

interface IReduxDispatchProps {
  UserLib: any
  PatientsLib: any
  PlusUserLib: any
}

interface IReduxProps extends IReduxStateProps, IReduxDispatchProps {}

interface IProps extends INativeProps, IReduxProps, RouteComponentProps {}
interface IRefElemProps {
  handleOpenDialog: () => void
}

const Content: React.FC<IProps> = props => {
  const dialog = React.useRef<IRefElemProps>()
  const [isShareModalOpen, setActiveShareModal] = React.useState(false)
  const [isEducatorsModalOpen, setActiveEducatorsModal] = React.useState(false)

  const {
    type,
    hasMenu,
    disableBackButton,
    oneRow,
    rightSide,
    title,
    plusIconAction,
    smallHeader,
    defaultRightSide,
    user,
    UserLib,
    className,
    userAuth,
    currentPatient
  } = props

  const defaultRightSideProps = (): IPopoverButtonOptions[] => {
    const { history, PatientsLib, PlusUserLib, plusUser } = props
    const toShowPlusInMenu = !plusUser
    const buttons = [
      // *temporary hidden
      // {
      //   key: 'account',
      //   label: 'Account',
      //   onClick: () => history.push('/profile')
      // },
      {
        key: 'instructions',
        label: 'Parental Instructions',
        onClick: () => dialog.current?.handleOpenDialog(),
        className: 'parental-instr-tour-step'
      },
      {
        key: 'share',
        label: 'Share',
        onClick: () => setActiveShareModal(true)
      },
      {
        key: 'feedback',
        label: 'Contact Support',
        onClick: () =>
          (window.location.href = `mailto:${supportEmail}?subject=GiantLeap%20Support%20Ticket`)
      },
      {
        key: 'logout',
        label: 'Sign Out',
        onClick: () => {
          UserLib.logout(
            () => {
              PatientsLib.clear()
              clearPlusUser(PlusUserLib)
              // location.href = 'uniwebview://action?signout=1'
              // const landing = process.env.REACT_APP_LANDING_URL
              // if (landing) {
              //   window.location.href = landing
              // }
            },
            (message: string) => {
              SnackbarService.showSnackbar('Error while logging out', 'error')
              console.error(`Error while logging out: ${message}`)
            }
          )
        }
      }
    ]

    if (currentPatient && !isEducator(user?.role) && currentPatient.educators) {
      buttons.splice(1, 0, {
        key: 'educators',
        label: 'Educator Permissions',
        onClick: () => setActiveEducatorsModal(true)
      })
    }
    const plus = {
      key: 'plus',
      label: 'Learn about Plus',
      onClick: () => history.push(_route.payment, { canGoBack: true })
    }
    if (toShowPlusInMenu) {
      buttons.unshift(plus)
    }
    if (isEducator(user?.role)) {
      buttons.shift()
    }
    return buttons
  }

  const renderMenuButton = () => (
    <React.Fragment>
      <IconButton
        color="inherit"
        aria-label="Menu"
        className="menu-icon-btn icon-btn"
        onClick={() => DrawerService.showDrawer()}
      >
        <Menu className="menu-icon" />
      </IconButton>
      <Drawer />
    </React.Fragment>
  )

  const renderBackButton = () => {
    const { goBackAction, history } = props

    return (
      <IconButton
        color="inherit"
        aria-label="Back"
        className="back-icon-btn icon-btn tooltip-wrap"
        onClick={() => {
          goBackAction ? goBackAction() : history.goBack()
        }}
      >
        <ArrowBackIosRoundedIcon className="back-icon" />
        <span className="tooltip__item tooltip__item--left tooltip__item--nowrap">
          My Children
        </span>
      </IconButton>
    )
  }

  const renderAddButton = () => {
    return (
      <IconButton
        color="inherit"
        aria-label="Back"
        className="plus-icon-btn icon-btn"
        onClick={() => plusIconAction()}
      >
        <AddIcon className="plus-icon" />
      </IconButton>
    )
  }

  const renderSearchBlock = () => {
    const { searchFieldAction, searchFieldPlaceholder } = props
    return (
      <Toolbar className="search-toolbar">
        {searchFieldAction ? (
          <div className="search-wrap">
            <div className="search-icon">
              <SearchIcon />
            </div>
            <InputBase
              className="search-input"
              placeholder={searchFieldPlaceholder}
              onChange={searchFieldAction}
            />
          </div>
        ) : null}
      </Toolbar>
    )
  }

  const renderContent = () => {
    const { customComponent } = props
    if (customComponent) {
      return customComponent
    } else if (title && !oneRow) {
      return (
        <Toolbar className="page-header-content">
          <Typography className="page-header-title">{title}</Typography>
        </Toolbar>
      )
    } else {
      return null
    }
  }

  const getTeachers = (): ITeacher[] => {
    return currentPatient.educators
      ? Object.keys(currentPatient.educators).map(key => ({
          name: currentPatient.educators[key],
          id: key
        }))
      : []
  }

  return (
    <>
      <AppBar
        className={classnames([
          'page-header',
          type === 'color' && 'has-background',
          className
        ])}
        position="static"
        color="default"
      >
        <Toolbar className="top-header">
          <div className="left">
            {hasMenu ? (
              renderMenuButton()
            ) : !disableBackButton ? (
              renderBackButton()
            ) : (
              <Logo size="4em" />
            )}
          </div>

          <div className="center">
            {oneRow ? <Typography className="title">{title}</Typography> : null}
          </div>
          <div className="right">
            {plusIconAction ? (
              renderAddButton()
            ) : rightSide ? (
              rightSide
            ) : defaultRightSide ? (
              <PopoverButton
                userData={user}
                buttonOptions={defaultRightSideProps()}
              />
            ) : null}
          </div>
        </Toolbar>
        {renderContent()}
        {type === 'color' && !smallHeader ? renderSearchBlock() : null}
      </AppBar>
      <ParentalInstructions
        ref={dialog}
        updateParentInstructComplete={UserLib.updateParentInstructComplete}
        userId={user?.userId}
      />
      <ShareModal
        open={isShareModalOpen}
        onClose={() => setActiveShareModal(false)}
        user={userAuth}
      />
      {currentPatient && (
        <TeachersModal
          open={isEducatorsModalOpen}
          setActive={setActiveEducatorsModal}
          childId={currentPatient.patientId}
          childName={currentPatient.first_name}
          teachers={getTeachers()}
        />
      )}
    </>
  )
}

const mapStateToProps = state => {
  return {
    user: state.user.data,
    userAuth: state.user.auth,
    plusUser: state.plus_user.isPlusUser,
    currentPatient: state.patients.currentPatient
  }
}
const mapDispatchToProps = dispatch => ({
  UserLib: bindActionCreators<any, any>(UserActions as any, dispatch),
  PatientsLib: bindActionCreators(PatientActions, dispatch),
  PlusUserLib: bindActionCreators(PlusUserActions, dispatch)
})

const connector = connect(mapStateToProps, mapDispatchToProps)

const WithHOCs = compose(withRouter, connector)(Content)

export default (props: INativeProps) => <WithHOCs {...props} />



// WEBPACK FOOTER //
// ./src/components/Header/index.tsx